import { createRoute } from "@tanstack/react-router";
import { rootRoute } from '../App';
import { FullPageLoader } from "../components/FullPageLoader";
import { getKeycloak } from '../libs/auth/keycloakInstance';
import { AuthenticatedView } from './AuthenticatedView.page';

export const authenticatedRoute = createRoute({
    getParentRoute: () => rootRoute,
    id: 'authenticated',
    component: AuthenticatedView,
    pendingComponent: () => <FullPageLoader />,
    beforeLoad: async () => {
        const kc = getKeycloak();
        if (!kc.authenticated) {
            await kc.login();
        }
    },
    loader: () => void 0
});
